/**
 * @generated SignedSource<<3991fc1a4df01e69133ffb1a41d76e83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetEstimatedValueRange_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceHelpers_item">;
  readonly " $fragmentType": "useGetEstimatedValueRange_item";
};
export type useGetEstimatedValueRange_item$key = {
  readonly " $data"?: useGetEstimatedValueRange_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetEstimatedValueRange_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetEstimatedValueRange_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "pricingGuidanceHelpers_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "c420905b0e718dede80029a6b1b387cc";

export default node;
